import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { EssayEdit } from './edit.component';
import { EssayPreview } from './preview.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var EssayEditLayout = styled.div.withConfig({
  displayName: "essaycomponent__EssayEditLayout",
  componentId: "sc-1gm15u7-0"
})(["display:", ";"], function (props) {
  return props.isFocus ? 'block' : 'none';
});
var EssayPreviewLayout = styled.div.withConfig({
  displayName: "essaycomponent__EssayPreviewLayout",
  componentId: "sc-1gm15u7-1"
})(["display:", ";"], function (props) {
  return props.isFocus ? 'none' : 'block';
});
export var Essay = function Essay(props) {
  var _useState = useState(false),
      isFocus = _useState[0],
      setIsFocus = _useState[1];

  var question = props.question,
      index = props.index,
      onDelete = props.onDelete,
      onUpdate = props.onUpdate,
      onUpdateType = props.onUpdateType,
      onFocusQuestion = props.onFocusQuestion,
      editingQuestionId = props.editingQuestionId,
      defaultDescription = props.defaultDescription;

  var useClickOutside = function useClickOutside(ref) {
    useEffect(function () {
      function handleClickAnotherPreviewComponent(event) {
        event.stopPropagation();
        var questionPreviewElements = document.querySelectorAll('[data-question-preview]');
        questionPreviewElements.forEach(function (previewElement) {
          if (previewElement === wrapperPreviewRef.current) return;

          if (ref.current && !ref.current.contains(event.target) && previewElement.contains(event.target)) {
            setIsFocus(false);
            return;
          }
        });
      }

      document.addEventListener('mousedown', handleClickAnotherPreviewComponent);
      return function () {
        document.removeEventListener('mousedown', handleClickAnotherPreviewComponent);
      };
    }, [ref]);
  };

  var useClickInside = function useClickInside(ref) {
    useEffect(function () {
      function handleClickInside(event) {
        if (ref.current && ref.current.contains(event.target)) {
          setIsFocus(true);
        }
      }

      document.addEventListener('mousedown', handleClickInside);
      return function () {
        document.removeEventListener('mousedown', handleClickInside);
      };
    }, [ref]);
  };

  var wrapperEditRef = useRef(null);
  useClickOutside(wrapperEditRef);
  var wrapperPreviewRef = useRef(null);
  useClickInside(wrapperPreviewRef);
  useEffect(function () {
    if (isFocus) {
      onFocusQuestion(index, question);
    }
  }, [isFocus, onFocusQuestion, index, question]);
  useEffect(function () {
    if (editingQuestionId === question.id.toString()) {
      setIsFocus(true);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  return /*#__PURE__*/_jsxs("div", {
    id: question.id.toString(),
    children: [/*#__PURE__*/_jsx(EssayEditLayout, {
      ref: wrapperEditRef,
      isFocus: isFocus,
      children: isFocus && /*#__PURE__*/_jsx(EssayEdit, _objectSpread(_objectSpread({}, props), {}, {
        question: question,
        index: index //question
        ,
        onDelete: onDelete,
        onUpdate: onUpdate,
        onUpdateType: onUpdateType,
        defaultDescription: defaultDescription
      }))
    }), /*#__PURE__*/_jsx(EssayPreviewLayout, {
      "data-question-preview": true,
      className: "question-content",
      ref: wrapperPreviewRef,
      isFocus: isFocus,
      children: /*#__PURE__*/_jsx(EssayPreview, {
        question: question,
        index: index
      })
    })]
  });
};